// extracted by mini-css-extract-plugin
export default {"img_under_dev":"UnderDevelopment_img_under_dev__OxSyt","spin":"UnderDevelopment_spin__3un9G","title":"UnderDevelopment_title__26NBe"};